<template>
  <div class="card">
    <div class="card-header">
      <span class="card-header-title">Send password reset link</span>
    </div>

    <div class="card-content">
      <form @submit.stop.prevent="send()">
        <div v-if="!code || (code && code == '')">
          <BForm
            :elements="form"
            mode="lazy"
            @valid="form.valid = $event"
            @submit="send()"
          ></BForm>
        </div>

        <div class="column content" v-if="code && code != ''">
          <p>
            You need the code below to reset your password.
          </p>

          <div
            class="tags has-addons margin-top-1 is-clickable"
            @click="copyToClipboard()"
          >
            <span class="tag is-medium is-dark">
              <span class="icon"><i class="mdi mdi-lock"></i></span>
            </span>
            <span id="code" class="tag is-medium is-primary">{{ code }}</span>
          </div>

          <p>
            Go to your inbox and follow the instructions. It can take a while to
            receive the email.
          </p>
        </div>

        <section class="footer-container">
          <button
            v-if="!code"
            :class="{ 'is-loading': isLoading }"
            :disabled="isLoading || !form.valid"
            class="button is-primary"
            type="submit"
          >
            Send
          </button>
          <button
            v-else
            @click.stop.prevent="code = ''"
            class="button is-default"
          >
            Restart
          </button>
        </section>

        <section class="buttons-section">
          <button
            type="button"
            class="simple-button is-fullwidth"
            @click.stop.prevent="$emit('action', 'signin')"
          >
            Go to sign in
          </button>
        </section>
      </form>
    </div>
  </div>
</template>

<script>
import BForm from "@/components/singles/BForm/component.vue";
import { copyToClipboard } from "@/utils/document";

export default {
  components: {
    BForm,
  },
  props: { value: Boolean },
  data() {
    return {
      isLoading: false,

      code: null,
      form: {
        valid: false,
        inputs: [
          {
            focus: true,
            icon: "mdi-email",
            name: "username",
            placeholder: "Email",
            type: "email",
            validation: "email",
            value: "",
          },
        ],
      },
    };
  },
  computed: {},
  async mounted() {
    this.isLoading = true;

    if (this.$store.state.auth.success) {
      this.reRoute();
    }
    this.isLoading = false;
  },
  methods: {
    copyToClipboard() {
      copyToClipboard("code");
      this.$helpers.notify("Copied", "Copied code to clipboard.", "info", 6000);
    },
    async send() {
      if (this.form.valid) {
        this.isLoading = true;

        try {
          const res = await this.$helpers.postApi(
            "user/sendpasswordlink",
            {
              mail: this.form.inputs[0].value,
            },
            { skipAuth: true, fullDataObject: true }
          );

          if (res.data && res.data.code) {
            this.$helpers.notify(
              "Email sent",
              "Check your inbox.",
              "success",
              -1
            );
            this.code = res.data.code;
            this.$nextTick(() => {
              this.copyToClipboard();
            });
          } else this.$helpers.notify("Error", "Unknown error.", "warning", -1);
        } catch ({ response }) {
          if (response.status === 400) {
            this.$helpers.notify(
              "Incorrect e-mail",
              "Make sure that the e-mail is correct.",
              "warning"
            );
          } else this.$helpers.notify("Error", "Unknown error.", "danger", -1);
        }

        this.isLoading = false;
        this.$helpers.clearForm(this.form);
      }
    },
  },
};
</script>

<style scoped>
.has-addons {
  cursor: pointer;
}
</style>
